import Modal from "react-bootstrap/Modal";
import TextInput from "../TextInputComponent/TextInput";
import Button from "../ButtonComponent/Button";
import { Col, Row } from "react-bootstrap";
import UploadIcon from "../../assets/images/Icons/uploadIcon.svg";
import CloseButton from "../../assets/images/Icons/closeIcon.svg";
import "./addContacts.css";

const AddContacts = ({
  show,
  setShow,
  contactsFile,
  setContactsFile,
  contactsFileRequired,
  setContactsFileRequired,
  contactsFilelabel,
  setContactsFilelabel,
  submitData,
}) => {
  const closeAddContactsModal = () => {
    setContactsFile();
    setContactsFileRequired(false);
    setContactsFilelabel("Select an Excel File");
    setShow(false);
  };
  return (
    <Modal show={show} aria-labelledby="contained-modal-title-vcenter" centered>
      <span>
        <img
          onClick={() => closeAddContactsModal()}
          className="close-btn"
          src={CloseButton}
        ></img>
      </span>
      <div className="add-contacts-modal">
        <div>
          <p className="add-contacts-text">Upload Contact Details</p>
        </div>
        <div>
          <label
            className={
              contactsFileRequired === false
                ? "upload-contacts-button"
                : "add-contacts-error-upload upload-contacts-button"
            }
          >
            <img className="mx-2" src={UploadIcon} alt="img" />
            <span>Upload</span>
            <input
              className="add-contacts-upload-button"
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              onChange={(e) => {
                let selectedFile = e.target.files[0];
                const acceptedFiles = [
                  ".csv",
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.ms-excel",
                ];
                if (
                  selectedFile &&
                  acceptedFiles.indexOf(selectedFile.type) === -1
                ) {
                  setContactsFilelabel("Invalid. Please select an excel file");
                  setContactsFile();
                  setContactsFileRequired(true);
                } else {
                  setContactsFile(selectedFile);
                  setContactsFilelabel(selectedFile.name);
                }
              }}
            />
          </label>
        </div>
        <p className="add-contacts-file-label">{contactsFilelabel}</p>
        <Button
          className="add-contacts-submit-button"
          text={"SUBMIT"}
          onClick={() => {
            contactsFile && submitData();
            contactsFile || setContactsFileRequired(true);
          }}
        />
      </div>
    </Modal>
  );
};

export default AddContacts;
